"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useDispatch } from "react-redux";

import { clearFieldErrors } from "@/lib/redux/slices/formSlice";

export default function RouteChangeHandler() {
  const pathname = usePathname();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearFieldErrors());
  }, [pathname, dispatch]);

  return null;
}
